import { formatters } from './formatters'
import { loaders } from './loaders'

export const extensions = { formatters, loaders }
